import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Chip,
  Dialog,
  TextField,
  IconButton,
  Tooltip,
  Autocomplete,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";

export default function StoreFilter(props) {
  const [open, setOpen] = React.useState(false);
  const [store, setStore] = useState(null);
  const [searchState, setSearchState] = useState([]);
  const [add, setAdd] = useState("");

  const Stores = [
    { id: 1, label: "موجود" },
    { id: 2, label: "ناموجود" },
  ];

  useEffect(() => {
    if (!props.store) {
      setStore("");
    }
  }, [props]);

  return (
    <Box
      sx={{
        gap: 2,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography variant="subtitle1">فیلتر : </Typography>
        <Tooltip title="افزودن">
          <IconButton onClick={() => setOpen(true)}>
            <AddCircleIcon
              sx={{
                color: "primary.main",
              }}
            />
          </IconButton>
        </Tooltip>
        <Box
          style={{ direction: "ltr", display: "flex", alignItems: "center" }}
        >
          {props.store && (
            <Chip
              label={Stores.find((m) => m.id == props.store)?.label}
              onDelete={(data) => {
                props.setStore("");
                setStore("");
              }}
              color="primary"
              sx={{
                px: 2,
                m: 0.5,
                "& .MuiChip-label	": {
                  px: 0,
                },
              }}
            />
          )}
        </Box>
      </Box>
      <Dialog
        maxWidth="sm"
        fullWidth
        onClose={() => {
          setOpen(false);
        }}
        open={open}
      >
        <Box sx={{ display: "flex", alignItems: "center", m: 3, my: 5 }}>
          <Autocomplete
            sx={{ mr: 3, width: "50%", justifyContent: "space-between" }}
            size="small"
            value={store ? store : ""}
            onChange={(event, newValue) => {
              if (newValue) {
                setStore(newValue);
              } else {
                setStore("");
              }
            }}
            fullWidth
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => {
              if (option) {
                return Stores.find((m) => m.id == option).label;
              }
              return "";
            }}
            options={Stores ? Stores.map((m) => m.id) : []}
            renderInput={(params) => (
              <TextField variant="outlined" {...params} label="وضعیت" />
            )}
          />

          <Button
            variant="contained"
            onClick={() => {
              props.setStore(store);
              setOpen(false);
            }}
            sx={{ width: "80px", mr: 1 }}
          >
            ثبت
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              setOpen(false);
            }}
            sx={{ width: "80px" }}
          >
            انصراف
          </Button>
        </Box>
      </Dialog>
    </Box>
  );
}
